import { cherryHillConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function CherryHillPage() {
  return <CityPageTemplate config={cherryHillConfig} />;
}